import Vue from 'vue'
import axios from 'axios'

const state = {
  settingData: {}
}

const getters = {
  settingData: state => {
    return state.settingData
  }
}

const mutations = {
  SET_CONFIG: (state, config) => {
    Vue.set(state.settingData, 'config', config)
  }
}

const actions = {
  async FetchConfig ({ commit }) {
    const responseData = await axios.get(window.location.origin + '/static/config.json')
    commit('SET_CONFIG', responseData.data.data)
  }
}

export default {
  state,
  getters,
  mutations,
  actions
}



// WEBPACK FOOTER //
// ./src/vuex/modules/setting.js